// created just to make it easier to mock
export const getInternalName = () =>
  Math.floor(1000000 + Math.random() * 9000000)
    .toString()
    .substring(0, 7);
